export default "__VITE_ASSET__BFF2BVA9__"